import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "name", "path", "isActive"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import config from 'utils/config';
import Box from 'components/Box';
import Icon from 'components/Icon';
import InlineList from 'components/InlineList';
import Tab from 'components/Tab';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function TabWithIcon(_ref) {
  var children = _ref.children,
    name = _ref.name,
    path = _ref.path,
    isActive = _ref.isActive,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Tab, _objectSpread(_objectSpread({
    as: NavLink,
    height: 56,
    className: isActive ? 'is-active' : '',
    to: path,
    state: {
      shouldResetScroll: false
    }
  }, otherProps), {}, {
    children: [/*#__PURE__*/_jsx(Icon, {
      name: name,
      mr: "xs"
    }), children]
  }));
}
function PlaylistTabs(_ref2) {
  var renderContent = _ref2.renderContent,
    renderComments = _ref2.renderComments;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var commentsIndex = pathname.indexOf('/comments');
  var isCommentsActive = commentsIndex !== -1;
  var basePath = isCommentsActive ? pathname.slice(0, commentsIndex) : pathname;

  // If comments are disabled, we just render the playlist's content
  // directly – no need for tabs.
  if (!config.enableComments) {
    return renderContent();
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      breakpoints: "s",
      textAlign: ['center', 'left'],
      borderBottom: "thin",
      pl: "xxs",
      mb: "m",
      children: /*#__PURE__*/_jsxs(InlineList, {
        spacing: "l",
        as: "nav",
        itemAs: "div",
        "aria-label": t('content_type_playlist'),
        children: [/*#__PURE__*/_jsx(TabWithIcon, {
          isActive: !isCommentsActive,
          end: true,
          path: basePath,
          name: "playlist",
          children: t('content_type_content_plural')
        }), /*#__PURE__*/_jsx(TabWithIcon, {
          isActive: isCommentsActive,
          path: "".concat(basePath, "/comments"),
          name: "chat",
          children: t('comments_title')
        })]
      })
    }), isCommentsActive ? renderComments() : renderContent()]
  });
}
export default PlaylistTabs;